import React from 'react';

import {
  useRecordContext, SelectField, TextField,
} from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import { legalFormTypeChoices } from '../../../../constants/legalForms';
import conflictFields from '../../../../constants/conflictFields';
import applyChoices from '../../applyChoices';
import { LegalFormParameters } from '../../questionParameters';

const CONTENT = {
  [languages.SV]: 'Bolagsform',
  [languages.EN]: 'Legal form of business',
  [languages.DE]: 'Rechtsform des Unternehmens',
};

export type LegalFormFormAnswer = {
  options: string;
  other?: string;
}

const ValueField = ({
  language,
  extraParameters,
}: {
  language?: Languages;
  extraParameters?: LegalFormParameters;
}) => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (!language) return null;

  if (value?.options === 'other') {
    return <TextField sx={sx} source="value.other" emptyText="-" fontWeight="bold" />;
  }

  const choices = applyChoices(
    legalFormTypeChoices(language),
    extraParameters?.options,
    extraParameters?.choiceLabels,
  );

  return <SelectField choices={choices} record={{ value }} sx={sx} source="value.options" emptyText="-" fontWeight="bold" />;
};

const LegalForm = ({ extraParameters }: { extraParameters?: LegalFormParameters }) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      source="legalForm"
      datapoint={conflictFields.LEGAL_FORM}
      identificationInfo={undefined}
    >
      <ValueField language={language} extraParameters={extraParameters} />
    </Answer>
  );
};

LegalForm.ValueField = ValueField;

export default LegalForm;
